
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faPinterest } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.svg';
import './Footer.css';
import { Request } from '../../context';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await Request('/subscribe', 'POST', { email });
      setStatus({ type: 'success', message: 'Successfully subscribed!' });
      setEmail('');
    } catch (err) {
      const errorMsg = err.payload?.error || 'Subscription failed. Please try again.';
      setStatus({ type: 'error', message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section brand-section">
          <Link to="/" className="footer-logo">
            <img src={logo} alt="Epoxy Garden Logo" />
            <span>Epoxy Garden</span>
          </Link>
          <p className="brand-description">
            Preserving nature's beauty in timeless epoxy resin.
          </p>
        </div>

        <div className="footer-section">
          <h3>Customer Care</h3>
          <ul>
            {/*<li><Link to="/shipping">Shipping</Link></li>*/}
            <li><Link to="/returns">Returns</Link></li>
            <li><Link to="/size-guide">Size Guide</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>About Us</h3>
          <ul>
            <li><Link to="/about">Our Story</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/wholesale">Wholesale</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Newsletter</h3>
          <p>Subscribe for updates and special offers</p>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="Enter your email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
          {status.message && (
            <p className={`status-message ${status.type}`}>
              {status.message}
            </p>
          )}
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://instagram.com"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://facebook.com"><FontAwesomeIcon icon={faFacebook} /></a>
            <a href="https://pinterest.com"><FontAwesomeIcon icon={faPinterest} /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2024 Epoxy Garden. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
